import { IfcGeometricRepresentationItem } from "./index.js";
import { IfcCurve } from "./index.js";
import { IfcPoint } from "./index.js";
import { IfcSurface } from "./index.js";
import { stepExtractOptional, stepExtractArrayToken, stepExtractArrayBegin, skipValue, } from "../../step/parsing/step_deserialization_functions.js";
/* This is generated code, don't modify */
import EntityTypesIfc from "./entity_types_ifc.gen.js";
///**
// * http://www.buildingsmart-tech.org/ifc/ifc4/final/html/link/ifcgeometricset.htm */
export class IfcGeometricSet extends IfcGeometricRepresentationItem {
    get type() {
        return EntityTypesIfc.IFCGEOMETRICSET;
    }
    get Elements() {
        if (this.Elements_ === void 0) {
            let cursor = this.getOffsetCursor(0);
            const buffer = this.buffer;
            const endCursor = buffer.length;
            if (stepExtractOptional(buffer, cursor, endCursor) === null) {
                return [];
            }
            const value = [];
            let signedCursor0 = stepExtractArrayBegin(buffer, cursor, endCursor);
            cursor = Math.abs(signedCursor0);
            while (signedCursor0 >= 0) {
                const value1Untyped = this.extractBufferReference(buffer, cursor, endCursor);
                if (!(value1Untyped instanceof IfcCurve) && !(value1Untyped instanceof IfcPoint) && !(value1Untyped instanceof IfcSurface)) {
                    throw new Error("Value in select must be populated");
                }
                const value1 = value1Untyped;
                if (value1 === void 0) {
                    throw new Error("Value in STEP was incorrectly typed");
                }
                cursor = skipValue(buffer, cursor, endCursor);
                value.push(value1);
                signedCursor0 = stepExtractArrayToken(buffer, cursor, endCursor);
                cursor = Math.abs(signedCursor0);
            }
            this.Elements_ = value;
        }
        return this.Elements_;
    }
    get Dim() {
        return this?.Elements?.[1 - 1].Dim;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
IfcGeometricSet.query = [EntityTypesIfc.IFCGEOMETRICSET, EntityTypesIfc.IFCGEOMETRICCURVESET];
IfcGeometricSet.expectedType = EntityTypesIfc.IFCGEOMETRICSET;
